<template>
  <component
    :is="getCustomComponent(advanced_option)"
    :id="
      `question-${question_index}-group-${questions_groups_index}-advanced-${advanced_option}-custom`
    "
    :question_index="question_index"
    :questions_groups_index="questions_groups_index"
  />
</template>

<script>
import AdvancedInheritance from './AdvancedInheritance'
import NoneOfTheAbove from './NoneOfTheAbove'

const components = {
  advanced_inheritance: 'AdvancedInheritance',
  none_of_the_above: 'NoneOfTheAbove',
}

export default {
  name: 'CustomRenderer',

  components: {
    AdvancedInheritance,
    NoneOfTheAbove,
  },

  props: {
    type: {
      type: String,
      default: '',
    },
    advanced_option: {
      type: String,
      default: '',
    },
    question_index: {
      required: true,
      type: Number,
    },
    questions_groups_index: {
      required: true,
      type: Number,
    },
    expandAll: {
      type: Boolean,
      default: false,
    },
  },

  methods: {
    getCustomComponent(option) {
      const component = components[option]

      if (component) return component

      return console.error(`Custom component for ${option} not found`)
    },
  },
}
</script>

<style scoped lang="scss"></style>
